import type { Components, Theme } from "@mui/material/styles";
import { RadiusToken } from "../../tokens/radii";

export const MuiLinearProgress: NonNullable<
  Components<Theme>["MuiLinearProgress"]
> = {
  styleOverrides: {
    root: ({ theme }) => ({
      display: "flex",
      width: "100%",
      height: theme.spacing(2),
      alignItems: "center",
      gap: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        borderRadius: RadiusToken.MAX,
      },
      backgroundColor: theme.vars!.palette.rmh.paper["7-brandFaint"].hover,
    }),
    bar: ({ theme }) => ({
      backgroundColor: theme.vars!.palette.rmh.paper["5-brandFilled"].rest,
    }),
  },
};
